module.exports = __webpack_public_path__ + "img/PDF_picture_icon@2x.e329d2e3.png";